<template>
  <div style="display: inline; text-align: left">
    <el-dialog width="1000px" top="10vh" title="导入记录" :visible.sync="dialogVisible">
      <el-table :data="historyList" class="table" v-loading="tableLoading">
        <el-table-column prop="import_time" label="导入时间">
          <template slot-scope="scope">
            {{ scope.row.import_time | parseTime }}
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人员"></el-table-column>
        <el-table-column prop="tag_name" label="标签名称"></el-table-column>
        <el-table-column prop="add_count" label="新增人数">
          <template slot-scope="scope">
            {{ scope.row.import_status === 1 ? '-' : scope.row.add_count }}
          </template>
        </el-table-column>
        <el-table-column prop="import_status" label="导入状态">
          <template slot-scope="scope">{{ scope.row.import_status | handleStatus }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="openDetail(scope.row)"
              :disabled="scope.row.import_status !== 2"
            >
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--内层的dialog-->
      <el-dialog width="800px" top="15vh" :visible.sync="dialogInnerVisible" append-to-body>
        <el-table :data="detailUserList" class="table-inner" v-loading="tableInnerLoading">
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="user_id" label="id"></el-table-column>
          <el-table-column prop="department" label="所属部门"></el-table-column>
          <el-table-column prop="email" label="邮箱"></el-table-column>
          <el-table-column prop="phone" label="电话"></el-table-column>
        </el-table>
        <div style="text-align: right">
          <el-pagination
            style="background-color: #ffffff; width: 100%"
            layout="total, prev, sizes, pager, next"
            :total="innerPageTotal"
            :page-sizes="g_pageSizesConfig"
            :page-size="innerPageSize"
            :current-page="innerPageIndex"
            @current-change="changeInnerPageIndex"
            @size-change="changeInnerPageSize"
          />
        </div>
      </el-dialog>
      <div style="text-align: right">
        <el-pagination
          style="background-color: #ffffff; width: 100%"
          layout="total, prev,sizes, pager, next, jumper"
          :total="pageTotal"
          :page-sizes="g_pageSizesConfig"
          :page-size="pageSize"
          :current-page="pageIndex"
          @current-change="changePageIndex"
          @size-change="changePageSize"
        />
      </div>
    </el-dialog>
    <el-button @click="dialogVisible = true" style="margin-left: 10px">导入记录</el-button>
  </div>
</template>

<script>
import { GetImportTagRecordById, GetImportTagRecordList } from '@/api/addressList';
import { parseTime } from '@/utils/time';
export default {
  name: 'LabelImportHistory',
  filters: {
    handleStatus(status) {
      switch (status) {
        case 1:
          return '导入中';
        case 2:
          return '导入成功';
        case 3:
          return '导入失败';
        default:
          return '-';
      }
    },
    parseTime,
    handleType(type) {
      switch (type) {
        case 1:
          return '人员';
        case 2:
          return '部门';
        default:
          return '-';
      }
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogInnerVisible: false,

      historyList: [],
      detailUserList: [],

      pageSize: 10,
      pageIndex: 1,
      pageTotal: 1,

      innerRecordId: 0,
      innerPageSize: 10,
      innerPageIndex: 1,
      innerPageTotal: 1,

      tableLoading: false,
      tableInnerLoading: false,
    };
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (val) {
          this.changePageIndex(1);
        }
      },
    },
  },
  methods: {
    getList() {
      this.tableLoading = true;
      GetImportTagRecordList({
        page_index: this.pageIndex,
        page_size: this.pageSize,
      })
        .then((res) => {
          this.pageTotal = res.total_num;
          this.historyList = res.tagRecord;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    changePageIndex(val) {
      this.pageIndex = val;
      this.getList();
    },
    changePageSize(val) {
      this.pageSize = val;
      this.getList();
    },
    changeInnerPageIndex(val) {
      this.innerPageIndex = val;
      this.getDetail();
    },
    changeInnerPageSize(val) {
      this.innerPageSize = val;
      this.getDetail();
    },
    openDetail(item) {
      this.dialogInnerVisible = true;
      this.innerPageIndex = 1;
      this.innerRecordId = item.record_id;
      this.getDetail();
    },
    // eslint-disable-next-line camelcase
    getDetail() {
      this.tableInnerLoading = true;
      GetImportTagRecordById({
        record_id: this.innerRecordId,
        page_index: this.innerPageIndex,
        page_size: this.innerPageSize,
      })
        .then((res) => {
          this.detailUserList = res.users;
          this.innerPageTotal = res.total_num;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.tableInnerLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.table {
  height: 700px;
  overflow-y: scroll;
}
.table-inner {
  height: 600px;
  overflow-y: scroll;
}
</style>
